import * as React from 'react';
import { withRouter } from 'react-router';
import { Link, RouteComponentProps } from 'react-router-dom';

import styled, { tstyled, keyframes } from '../theme';
import { ProjectTypeRenderer } from '../models/ProjectType';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-30%);
  }

  to {
    opacity: 1;
    transform: none;
  }
`;

const Container = tstyled<{ count: number }>(styled.div)`
  padding-top: 20px;
  width: 65%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  animation-name: ${fadeIn};
  animation-fill-mode: forwards;
  animation-duration: 0.8s;
  animation-timing-function: ease;
  opacity: 0;
  animation-delay: 0.22s;
  height: 69px;

  @media (max-width: ${props => props.theme.mobileBreakpoint - 1}px) {
    ${props => props.count === 2 && 'padding: 10px 10px 0 10px;'}
    width: 100%;
  }

  @media (max-width: ${props => props.theme.maxWidth}) {
    ${props => props.count === 3 && 'padding: 10px 10px 0 10px;'}
  }

  > * {
    ${props => props.count === 2 && 'width: 49%;'}
    ${props => props.count === 3 && 'width: 32%;'}
  }
`;

const NavItem = tstyled<{ count: number; active: boolean }>(styled.div)`
  text-align: center;
  transition: 0.2s ease background-color;
  will-change: background-color;
  
  a {
    text-decoration: none;
    display: flex;
    width: 100%;
    height: 100%;
    color: #9f5f1e;
    line-height: 1.2;
    padding: 15px 0;
    justify-content: center;
    align-items: center;
    
    @media(max-width: ${props => props.theme.aboutBreakpoint - 1}px) {
      ${props => props.count === 3 && 'padding: 8px 8px;'};
    }

    span {
      transform: ${props => (props.active ? 'scaleY(-1)' : 'none')};
    }

    @media(min-width: ${props => props.theme.mobileBreakpoint}px) {
      &:hover {
        span {
          transform: scaleY(-1);
        }
      }
    }


    @media (min-width: 1800px) {
      font-size: 0.8vw;
    }
  }
`;

export const projectTypeColorMap = {
  curatorial: '214,199,169',
  personal: '235,207,158',
  commission: '216,193,170',
};

type IProps = RouteComponentProps<{ projectType: string }>;

class ProjectTypeNav extends React.Component<IProps> {
  shouldComponentUpdate(nextProps: IProps) {
    return (
      this.props.match.params.projectType !== nextProps.match.params.projectType
    );
  }

  render() {
    const selectedProjectType = this.props.match.params.projectType;

    return (
      <ProjectTypeRenderer
        render={({ data }) => {
          return (
            <Container count={data.items.length}>
              {data.items.map(item => (
                <NavItem
                  count={data.items.length}
                  style={{
                    backgroundColor: `rgba(${
                      projectTypeColorMap[item.fields.slug]
                    }, ${selectedProjectType === item.fields.slug ? 0.5 : 1})`,
                  }}
                  key={item.fields.slug}
                  active={selectedProjectType === item.fields.slug}
                >
                  <Link to={`/project/${item.fields.slug}`}>
                    <span>{item.fields.name} Projects</span>
                  </Link>
                </NavItem>
              ))}
            </Container>
          );
        }}
      />
    );
  }
}

export default withRouter(ProjectTypeNav);



// WEBPACK FOOTER //
// ./src/components/ProjectTypeNav.tsx